module.exports = "<div class=\"modal-body\">\n  Inivitation Sent successfully\n</div>\n"